__turbopack_context__.v({
  "accordionSlideOverwrite": "MfaLoginModal-module-scss-module__QlC2Ha__accordionSlideOverwrite",
  "content": "MfaLoginModal-module-scss-module__QlC2Ha__content",
  "error": "MfaLoginModal-module-scss-module__QlC2Ha__error",
  "fadeIn": "MfaLoginModal-module-scss-module__QlC2Ha__fadeIn",
  "fadeOut": "MfaLoginModal-module-scss-module__QlC2Ha__fadeOut",
  "footer": "MfaLoginModal-module-scss-module__QlC2Ha__footer",
  "header": "MfaLoginModal-module-scss-module__QlC2Ha__header",
  "modal": "MfaLoginModal-module-scss-module__QlC2Ha__modal",
  "overlay": "MfaLoginModal-module-scss-module__QlC2Ha__overlay",
  "pinSlot": "MfaLoginModal-module-scss-module__QlC2Ha__pinSlot",
  "resendLink": "MfaLoginModal-module-scss-module__QlC2Ha__resendLink",
  "scaleIn": "MfaLoginModal-module-scss-module__QlC2Ha__scaleIn",
  "scaleOut": "MfaLoginModal-module-scss-module__QlC2Ha__scaleOut",
  "subtitle": "MfaLoginModal-module-scss-module__QlC2Ha__subtitle",
  "title": "MfaLoginModal-module-scss-module__QlC2Ha__title",
  "zoomIn": "MfaLoginModal-module-scss-module__QlC2Ha__zoomIn",
  "zoomOut": "MfaLoginModal-module-scss-module__QlC2Ha__zoomOut",
});
